import { ReactNode } from "react";
import { Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";

type ActionCardProps = {
	icon: ReactNode;
	title: string;
	description?: string;
	onClick: VoidFunction;
};

export const ActionCard = ({ icon, title, description, onClick }: ActionCardProps) => {

	return (
		<Card>
			<CardActionArea
				onClick={onClick}
				sx={{
					display: "flex",
					alignItems: "start",
					justifyContent: "start",
					height: "100%",
					p: 2,
					"&:hover": {
						backgroundColor: "action.selectedHover",
					},
				}}
			>
				<CardContent sx={{width: "100%", height: '100%'}}>
					<Stack 
						direction={"row"} 
						spacing={2} 
						width='100%' 
						height='100%'
						alignItems={"center"} 
						justifyContent={"center"}
					>
						{icon}
						<Stack >
							<Typography variant="h6" fontWeight={500}>{title}</Typography>
							{ description && (
								<Typography variant="body1" color="text.secondary">
									{description}
								</Typography>
							) }
						</Stack>
					</Stack>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};
